// src/pages/SuperAdmin/CountryAdmins/countryAdminApi.js
import api from "../../../components/axiosComp";

export async function listCountryAdmins(params = {}) {
  const { q, active } = params;
  const query = new URLSearchParams();
  if (q) query.set("q", q);
  if (typeof active !== "undefined") query.set("active", active);

  const { data } = await api.get(
    `/api/super-admin/country-admins${query.toString() ? `?${query.toString()}` : ""}`
  );
  return data?.admins || [];
}

export async function createCountryAdmin(payload) {
  const { data } = await api.post("/api/super-admin/country-admins", payload);
  return data;
}

export async function updateCountryAdminSupport(id, payload) {
  const { data } = await api.patch(
    `/api/super-admin/country-admins/${id}/support-contact`,
    payload,
  );
  return data;
}

export async function toggleCountryAdminStatus(id, active) {
  const { data } = await api.patch(
    `/api/super-admin/country-admins/${id}/status`,
    { active }
  );
  return data;
}
